import { linearRegression } from "@/utils/linearRegression";
import { DunsRosFlowRegimes } from "../../tubingFrictionLoss/dunsRos";
import type { FluidFrictionPrerequisites } from "../d";

export function getL1(
  pipeDiameterNumber: number,
  yL1: number[],
  x: number[]
): number {
  // COMMENTED ABOVE AND ADDED THE FOLLOWING
  const regressionData = x.map((x, i) => {
    return {
      x,
      y: yL1[i]
    };
  });
  const { m, b } = linearRegression(regressionData);
  const forecast = m * pipeDiameterNumber + b;

  if (forecast > 2) {
    return 2;
  } else if (forecast < 1) {
    return 1;
  } else {
    return forecast;
  }
}

export function getL2(
  pipeDiameterNumber: number,
  yL2: number[],
  x: number[]
): number {
  const regressionData = x.map((x, i) => {
    return {
      x,
      y: yL2[i]
    };
  });
  const { m, b } = linearRegression(regressionData);
  const forecast = m * pipeDiameterNumber + b;

  if (forecast > 1.1) {
    return 1.1;
  } else if (forecast < 0.5) {
    return 0.5;
  } else {
    return forecast;
  }
}

export function getFlowRegimeDunsRos(
  flowRegimePrerequisites: FluidFrictionPrerequisites
): DunsRosFlowRegimes {
  const {
    gasVelocityNumber,
    liquidVelocityNumber,
    pipeDiameterNumber,
    inSituGasFlowRateCFS,
    inSituLiquidFlowRateCFS
  } = flowRegimePrerequisites;

  // D172: =D142/(D142+D145)
  const inSituLiquidHoldUp =
    inSituLiquidFlowRateCFS / (inSituLiquidFlowRateCFS + inSituGasFlowRateCFS);

  const Ls = 50 + 36 * liquidVelocityNumber;
  const Lm = 75 + 84 * liquidVelocityNumber ** 0.75;

  const yL1 = [2, 2, 1, 1];
  const yL2 = [0.5, 0.75, 1.1, 1.1];
  const x = [15, 30, 67, 400];

  const L1 = getL1(pipeDiameterNumber, yL1, x);
  const L2 = getL2(pipeDiameterNumber, yL2, x);

  if (inSituLiquidHoldUp > 0.999) {
    return DunsRosFlowRegimes.LIQUID;
  } else if (
    gasVelocityNumber >= 0 &&
    gasVelocityNumber <= L1 + L2 * liquidVelocityNumber
  ) {
    return DunsRosFlowRegimes.BUBBLE;
  } else if (
    gasVelocityNumber >= L1 + L2 * liquidVelocityNumber &&
    gasVelocityNumber <= Ls
  ) {
    return DunsRosFlowRegimes.SLUG;
  } else if (gasVelocityNumber > Lm) {
    return DunsRosFlowRegimes.MIST;
  } else if (Ls < gasVelocityNumber && gasVelocityNumber < Lm) {
    return DunsRosFlowRegimes.TRANSITION;
  } else {
    return DunsRosFlowRegimes.LIQUID;
  }
}
